import { render, staticRenderFns } from "./index.vue?vue&type=template&id=45f10ec2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=45f10ec2&prod&lang=scss&scoped=true"
import style1 from "@/styles/pc.css?vue&type=style&index=1&id=45f10ec2&prod&scoped=true&lang=css&external"
import style2 from "./index.vue?vue&type=style&index=2&id=45f10ec2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f10ec2",
  null
  
)

export default component.exports